import { render, staticRenderFns } from "./NotificationView.vue?vue&type=template&id=498c6dfc&scoped=true"
import script from "./NotificationView.vue?vue&type=script&lang=js"
export * from "./NotificationView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498c6dfc",
  null
  
)

export default component.exports